import { ValueOf } from 'global';
import { FinanceProgramFormValues, MarkupMethods, MarkupType, Structures } from '../types';

export function convertProgramConfigToFormValues(
  programConfig: any
): Partial<ValueOf<FinanceProgramFormValues, 'financeQuote'>> {
  const isCommonRate = new Set(programConfig.terms.map((termValue: any) => termValue?.rate)).size === 1;

  let markupMethod: MarkupMethods | undefined = undefined;
  let dealerMarkup: number | undefined = undefined;
  let structure: Structures | undefined = undefined;

  if (programConfig.isSubsidized) {
    structure = Structures.Subsidy;
    markupMethod = MarkupMethods.CustomerRate;
    dealerMarkup = programConfig.customerRate;
  } else if (programConfig.customerRate) {
    markupMethod = MarkupMethods.CustomerRate;
    dealerMarkup = programConfig.customerRate;
    if (dealerMarkup && dealerMarkup < programConfig.terms[0].rate) {
      structure = Structures.Subsidy;
    } else {
      structure = Structures.Markup;
    }
  } else if (programConfig.dealerMarkup) {
    markupMethod = MarkupMethods.MarkupPercentage;
    dealerMarkup = programConfig.dealerMarkup;
    structure = Structures.Markup;
  } else {
    structure = Structures.None;
  }

  return {
    structure,
    markupMethod,
    rateType: programConfig.rateType,
    programName: programConfig.financeProgramName,
    paymentCalculationMethod: programConfig.paymentPeriodTiming,
    minimumRequiredDownPayment: programConfig?.minimumRequiredDownPayment ?? 0,
    dealerMarkup: dealerMarkup ? +dealerMarkup.toFixed(2) : null,
    markupRate: dealerMarkup ? +dealerMarkup.toFixed(2) : null,
    advancePayment: programConfig.numberOfAdvancePayments?.toString() ?? '',
    daysToFirstPayment: programConfig.daysToFirstPayment?.toString() ?? '',
    terms: programConfig.terms
      .map((termValue: any) => (termValue?.term ? String(termValue?.term) : ''))
      .filter(Boolean),
    commonRate: isCommonRate ? programConfig.terms[0].rate : 0,
    specifyRates: !isCommonRate
      ? programConfig.terms.map((termValue: any) => ({ term: String(termValue?.term), rate: String(termValue?.rate) }))
      : [],
    fee: [
      ...(programConfig?.flatFees?.map((f: any) => mapFeeValue(f, MarkupType.Flat)) ?? []),
      ...(programConfig?.percentageFees?.map((f: any) => mapFeeValue(f, MarkupType.Percentage)) ?? []),
    ],
    specifyRate: !isCommonRate,
    specifyLenderMarketRates: (programConfig.subsidyCapConfiguration?.lenderMarketRates ?? []).map(
      (lenderMarketRate: any) => ({
        rate: lenderMarketRate.rate,
        term: lenderMarketRate.term,
      })
    ),
    configureSubsidyCap: !!programConfig.subsidyCapConfiguration,
    subsidyType: programConfig.subsidyType,
    subsidyCapConfiguration: programConfig.subsidyCapConfiguration,
  };
}

const mapFeeValue = (fee: any, type: MarkupType) => ({ ...fee, type });
